export class BaseModel {
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }

    public assign(values: Object = {}) {
        Object.assign(this, values);
    }
}